import { ANGLE_360, SVG_CIRCLE_RADIUS } from './constants.js';

// @TODO Find a way to do this globally
const CSS_OUTPUT_PRECISION = 5;
const toCssPrecision = (value) => 
// Division by one removes trailing zeros
parseFloat(value.toPrecision(CSS_OUTPUT_PRECISION)) / 1;
const arc = (angle) => toCssPrecision(SVG_CIRCLE_RADIUS * angle);
const strokeDasharray = (arg) => {
    var _a;
    const angle = typeof arg === 'number'
        ? arg
        : typeof arg === 'object' && 'strokeAngle' in arg
            ? (_a = arg.strokeAngle) !== null && _a !== void 0 ? _a : 0
            : 0;
    return [angle, ANGLE_360 - angle].map(arc).join(' ');
};

export { arc, strokeDasharray, toCssPrecision };
//# sourceMappingURL=util.js.map
